import { fetchApiWithError } from '@upright/ui/api/common/fetchers/fetch-with-error';
import { ImpactSizeFactorByImpactCodeAndValence } from '../../../../../common/model/input/impact-size-factors/types';

export async function fetchImpactSizeFactors(version: string) {
  return await fetchApiWithError<ImpactSizeFactorByImpactCodeAndValence>(`/impact-size-factors/${version}`, 'GET');
}

export async function triggerUpdate() {
  return await fetchApiWithError<ImpactSizeFactorByImpactCodeAndValence>('/impact-size-factors', 'POST');
}
